import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmFilterManagerError extends TmBaseError {
  public name = 'TmFilterManagerError'
}
